import React from "react";
import { CssBaseline, makeStyles, MuiThemeProvider, StylesProvider, jssPreset } from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import darkTheme from "./components/util/themes/darkTheme";
import lightTheme from "./components/util/themes/lightTheme";
import Router from "./router";

import { selectTheme } from "./features/data/theme/themeSlice";

import { SnackbarProvider } from "notistack";
import { shallowEqual, useSelector } from "react-redux";
import axios from "axios";
import rtl from "jss-rtl";
import { create } from "jss";
import jMoment from "moment-jalaali";
import JalaliUtils from "@date-io/jalaali";
import "./features/convertDigits";

jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: false });
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

axios.interceptors.request.use(function (config) {
  config.headers["Content-Type"] = "application/json;charset=UTF-8";
  config.headers["Accept"] = "application/json;charset=UTF-8";
  return config;
});

const useStyles = makeStyles({
  buildingsBackground: {
    position: "fixed",
    bottom: 0,
    opacity: "0.3",
    zIndex: -10000,
    right: -200,
  },
});
export default function App() {
  const classes = useStyles();
  const { theme } = useSelector(selectTheme, shallowEqual);

  return (
    <StylesProvider jss={jss}>
      <MuiThemeProvider theme={theme === "dark" ? darkTheme : lightTheme}>
        <MuiPickersUtilsProvider utils={JalaliUtils} locale='fa-IR'>
          <SnackbarProvider
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            TransitionProps={{
              direction: "right",
            }}
            transitionDuration={400}
          >
            <CssBaseline />
            {/* <img src='/static/media/buildings.svg' className={classes.buildingsBackground} alt='buildings' /> */}
            <Router />
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    </StylesProvider>
  );
}
